export const REQUEST_LOGIN = 'REQUEST_LOGIN'
export const REQUEST_OUT = 'REQUEST_OUT'
export const SET_STATE_SEARCHPARAMS = 'SET_STATE_SEARCHPARAMS'
export const SET_SCREEN_INFO = 'SET_SCREEN_INFO'
export const SET_SELSTATIONINFO = 'SET_SELSTATIONINFO'

// 退出登录
export function logout(payload) {
    return {
        type: REQUEST_OUT,
        payload
    }
}
// 登录成功后
export function success(payload) {
    return {
        type: REQUEST_LOGIN,
        payload
    }
}

export function setStateSearchParams(payload) {
    return {
        type: SET_STATE_SEARCHPARAMS,
        payload
    }
}

// 设置大屏数据
export function setScreenInfo(payload) {
    return {
        type: SET_SCREEN_INFO,
        payload
    }
}

export function setStateSelStationInfo(payload) {
    return {
        type: SET_SELSTATIONINFO,
        payload
    }
}


